var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"note-delete-modal","content-class":"delete-modal-content","title":"Supprimer une note","ok-title":"Supprimer","ok-variant":"danger","cancel-title":"Annuler"},on:{"ok":_vm.handleOk}},[(_vm.selected !== null)?_c('div',[_c('div',[_vm._v("\n      Supprimer la note \""+_vm._s(_vm.selected.title)+"\" ?\n    ")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f17ed3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/note/NoteDeleteModal.vue
// module id = i3MK
// module chunks = 0